/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import {
  WebTypeViewField,
  WebField,
  WebRecord,
  WebList,
  WebElement,
  LogonSettings,
  WebSortConfig,
  WebFieldConfig,
  WebListConfig,
  WebRecordType,
  WsRefPerson,
  WsRefOrgunit,
  WsRefOrgunitByInfo,
  WsRefShiftCounter,
  WsRefShifttype,
  WsRefTaskDef,
  WsRefTask,
  WsRefAccount,
  WsRefProject,
  WsRefDimensionItem,
  globalSettingsSchema,
  webElementSchema,
  webFieldConfigSchema,
  webFieldSchema,
  webListConfigSchema,
  webListSchema,
  webRecordSchema,
  webRecordTypeSchema,
  webSortConfigSchema,
  webTypeViewFieldSchema,
  wsRefAccountByNameSchema,
  wsRefAccountSchema,
  wsRefDimensionItemByNameSchema,
  wsRefDimensionItemSchema,
  wsRefOrgunitByInfoSchema,
  wsRefOrgunitSchema,
  wsRefPersonByAuxSchema,
  wsRefPersonByNameSchema,
  wsRefPersonBySalaryIdSchema,
  wsRefPersonSchema,
  wsRefProjectByNameSchema,
  wsRefProjectSchema,
  wsRefShiftCounterSchema,
  wsRefShiftDefByExternalIdSchema,
  wsRefShiftDefByIdSchema,
  wsRefShiftDefByNameSchema,
  wsRefShiftDefSchema,
  wsRefShiftTypeByExternalIdSchema,
  wsRefShiftTypeByNameSchema,
  wsRefShifttypeSchema,
  wsRefTaskByExternalIdSchema,
  wsRefTaskByNameSchema,
  wsRefTaskDefByExternalIdSchema,
  wsRefTaskDefByNameSchema,
  wsRefTaskDefSchema,
  wsRefTaskSchema,
  globalSettingsJsonSchema,
  webElementJsonSchema,
  webFieldConfigJsonSchema,
  webFieldJsonSchema,
  webListConfigJsonSchema,
  webListJsonSchema,
  webRecordJsonSchema,
  webRecordTypeJsonSchema,
  webSortConfigJsonSchema,
  webTypeViewFieldJsonSchema,
  wsRefAccountByNameJsonSchema,
  wsRefAccountJsonSchema,
  wsRefDimensionItemByNameJsonSchema,
  wsRefDimensionItemJsonSchema,
  wsRefOrgunitByInfoJsonSchema,
  wsRefOrgunitJsonSchema,
  wsRefPersonByAuxJsonSchema,
  wsRefPersonByNameJsonSchema,
  wsRefPersonBySalaryIdJsonSchema,
  wsRefPersonJsonSchema,
  wsRefProjectByNameJsonSchema,
  wsRefProjectJsonSchema,
  wsRefShiftCounterJsonSchema,
  wsRefShiftDefByExternalIdJsonSchema,
  wsRefShiftDefByIdJsonSchema,
  wsRefShiftDefByNameJsonSchema,
  wsRefShiftDefJsonSchema,
  wsRefShiftTypeByExternalIdJsonSchema,
  wsRefShiftTypeByNameJsonSchema,
  wsRefShifttypeJsonSchema,
  wsRefTaskByExternalIdJsonSchema,
  wsRefTaskByNameJsonSchema,
  wsRefTaskDefByExternalIdJsonSchema,
  wsRefTaskDefByNameJsonSchema,
  wsRefTaskDefJsonSchema,
  wsRefTaskJsonSchema,
} from './Common_api';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, FavoriteStatusEnum, NotificationStatusEnum, TeamShiftStatusEnum, ExchangeCandidateFilterEnum, SwapIsUsedEnum, ExchangeTypeEnum, ExchangeStatusEnum, AvailabilityOpenHandlingEnum, WebmethodVoidPlaceholderEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, FavoriteStatusSchema, NotificationStatusSchema, TeamShiftStatusSchema, ExchangeCandidateFilterSchema, SwapIsUsedSchema, ExchangeTypeSchema, ExchangeStatusSchema, AvailabilityOpenHandlingSchema, WebmethodVoidPlaceholderSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema, FavoriteStatusJsonSchema, NotificationStatusJsonSchema, TeamShiftStatusJsonSchema, ExchangeCandidateFilterJsonSchema, SwapIsUsedJsonSchema, ExchangeTypeJsonSchema, ExchangeStatusJsonSchema, AvailabilityOpenHandlingJsonSchema, WebmethodVoidPlaceholderJsonSchema } from './enumLib_api';
export const teamSchema = z.object({
	id: z.string(),
	label: z.string(),
	parentId: z.string(),
	unitUilabel: z.string(),
	canOffer: z.boolean(),
	favoriteStatus: FavoriteStatusSchema,
	notificationStatus: NotificationStatusSchema,
	groupMemberCount: z.int()
});

export const teamJsonSchema = z.object({
	id: z.string().describe("from persongroup.groupid"),
	label: z.string().describe("from persongroup.uilabel"),
	parentId: z.string().describe("from persongroup.unitid"),
	unitUilabel: z.string().describe("from persongroup.unitid.uilabel"),
	canOffer: z.boolean().describe("Whether shifts can be offered to this persongroup. Always true when swapIsUsed=everywhere. Always false when swapIsUsed=no"),
	favoriteStatus: FavoriteStatusJsonSchema,
	notificationStatus: NotificationStatusJsonSchema,
	groupMemberCount: z.int().describe("The number of members in the group")
}).describe("The persongroupid and label");

/**
	The persongroupid and label
	Responsible: JBL, Updated: 20240208
*/
export class Team {
	constructor(
		/** from persongroup.groupid */
		public id: string,
		/** from persongroup.uilabel */
		public label: string,
		/** from persongroup.unitid */
		public parentId: string,
		/** from persongroup.unitid.uilabel */
		public unitUilabel: string,
		/** Whether shifts can be offered to this persongroup. Always true when swapIsUsed=everywhere. Always false when swapIsUsed=no */
		public canOffer: boolean,
		public favoriteStatus: FavoriteStatusEnum,
		public notificationStatus: NotificationStatusEnum,
		/** The number of members in the group */
		public groupMemberCount: number,
	) {}
}

export const personSchema = z.object({
	id: z.int(),
	name: z.string(),
	phoneList: z.array(z.string()),
	email: z.string(),
	initials: z.string(),
	isFictive: z.boolean()
});

export const personJsonSchema = z.object({
	id: z.int().describe("from person1.personid"),
	name: z.string(),
	phoneList: z.array(z.string()).describe("The person's phone numbers (person1.phone, person1.altphone, and person1.mobilphone, but only if set)"),
	email: z.string(),
	initials: z.string(),
	isFictive: z.boolean().describe("Whether the person is a fictive person")
}).describe("Personal information shown in TeamPlan");

/**
	Personal information shown in TeamPlan
	Responsible: LABO, Updated: 20180912
*/
export class Person {
	constructor(
		/** from person1.personid */
		public id: number,
		public name: string,
		/** The person's phone numbers (person1.phone, person1.altphone, and person1.mobilphone, but only if set) */
		public phoneList: string[],
		public email: string,
		public initials: string,
		/** Whether the person is a fictive person */
		public isFictive: boolean,
	) {}
}

export const teamDutySchema = z.object({
	salarysort: z.string(),
	salarysortText: z.string(),
	start: z.int().optional().nullable().default(null),
	end: z.int().optional().nullable().default(null),
	clockcode: z.string().optional().nullable().default(null)
});

export const teamDutyJsonSchema = z.object({
	salarysort: z.string().describe("Salarysort for duty"),
	salarysortText: z.string().describe("Long text for duty"),
	start: z.int().optional().nullable().default(null).describe("Timeoffset between 0 and 1439"),
	end: z.int().optional().nullable().default(null).describe("Timeoffsetend between 1 and 1440"),
	clockcode: z.string().optional().nullable().default(null)
}).describe("TeamDuty - coop se only. Dutylines on  the shift");

/**
	TeamDuty - coop se only. Dutylines on  the shift
	Responsible: JMQ, Updated: 20190206
*/
export class TeamDuty {
	constructor(
		/** Salarysort for duty */
		public salarysort: string,
		/** Long text for duty */
		public salarysortText: string,
		/** Timeoffset between 0 and 1439 */
		public start: number | null = null,
		/** Timeoffsetend between 1 and 1440 */
		public end: number | null = null,
		public clockcode: string | null = null,
	) {}
}

export const teamActivitySchema = z.object({
	start: z.int(),
	end: z.int(),
	label: z.string()
});

export const teamActivityJsonSchema = z.object({
	start: z.int().describe("Timeoffset between 0 and 1439"),
	end: z.int().describe("Timeoffsetend between 1 and 1440"),
	label: z.string().describe("Computed from either activity_reg.activityLabel or prd_task_reg.name")
}).describe("teamActivity - Can either come from an activity or task");

/**
	teamActivity - Can either come from an activity or task
	Responsible: JBL, Updated: 20230808
*/
export class TeamActivity {
	constructor(
		/** Timeoffset between 0 and 1439 */
		public start: number,
		/** Timeoffsetend between 1 and 1440 */
		public end: number,
		/** Computed from either activity_reg.activityLabel or prd_task_reg.name */
		public label: string,
	) {}
}

export const teamShiftSchema = z.object({
	id: z.string(),
	label: z.string(),
	type: z.string(),
	shiftDefId: z.string(),
	period: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	personId: z.int(),
	formerPersonId: z.int(),
	status: TeamShiftStatusSchema,
	dutyLines: z.array(z.lazy(() => teamDutySchema)),
	activities: z.array(z.lazy(() => teamActivitySchema)),
	tasks: z.array(z.lazy(() => teamActivitySchema)),
	responsibilities: z.array(z.string()),
	isTimeEditable: z.boolean(),
	numSwapSuggestions: z.int().optional().nullable().default(null),
	deviatingPayerUiLabel: z.string().optional().nullable().default(null),
	dutyLinesOriginal: z.array(z.lazy(() => teamDutySchema)).optional().nullable().default(null),
	absenceLabel: z.string().optional().nullable().default(null)
});

export const teamShiftJsonSchema = z.object({
	id: z.string().describe("Opaque, an internal representation of the shift_reg's primary key. In the planned \"production-version\" of TeamPlan should can only refer to a task resouce constraint (if the shift is generated from a task)."),
	label: z.string().describe("Computed from the shift_reg's shift_def or shortlabel (or start and end times if the shift_def is the *-shift)"),
	type: z.string().describe("Subset of ShiftTypeId"),
	shiftDefId: z.string().describe("from shift_reg.shiftid. The template used for the shift."),
	period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }),
	personId: z.int(),
	formerPersonId: z.int().describe("optional: The previous owner if this shift was constructed via a copyrequest, or -1. TODO_LABO, the shift_reg remark also has this information and we do not actually set this field, so we should just remove the field"),
	status: TeamShiftStatusJsonSchema,
	dutyLines: z.array(z.lazy(() => teamDutyJsonSchema)).describe("Duties on the shift"),
	activities: z.array(z.lazy(() => teamActivityJsonSchema)).describe("Activities which are a subset of the shift period"),
	tasks: z.array(z.lazy(() => teamActivityJsonSchema)).describe("Task assignments which are a subset of the shift period"),
	responsibilities: z.array(z.string()).describe("Activities or task assignments which are a superset of the shift period"),
	isTimeEditable: z.boolean().describe("Can the times be changed"),
	numSwapSuggestions: z.int().optional().nullable().default(null).describe("The number of exchange offers/suggestions/applications. Only defined if status in (swapActionRequired, offerActionRequired)"),
	deviatingPayerUiLabel: z.string().optional().nullable().default(null).describe("UIlabel of payer unit. Only defined if shift has dutyline with deviating payer."),
	dutyLinesOriginal: z.array(z.lazy(() => teamDutyJsonSchema)).optional().nullable().default(null).describe("The original duties before availability conversion. Only set on converted shifts, which can be ended."),
	absenceLabel: z.string().optional().nullable().default(null).describe("Computed from shiftType PublishableLabel or shiftTypeLabel depending on if user can see confidential info. Only set on converted shifts.")
}).describe("TeamShift. A thing that needs to be done, a shift_reg. How shifts are interpreted by the business logic is hidden from the App. We cannot store notes on shifts, but we could return a list of notes on the day of the shift, or we could store daymessages referring to the shift");

/**
	TeamShift. A thing that needs to be done, a shift_reg. How shifts are interpreted by the business logic is hidden from the App. We cannot store notes on shifts, but we could return a list of notes on the day of the shift, or we could store daymessages referring to the shift
	Responsible: JBL, Updated: 20240612
*/
export class TeamShift {
	constructor(
		/** Opaque, an internal representation of the shift_reg's primary key. In the planned "production-version" of TeamPlan should can only refer to a task resouce constraint (if the shift is generated from a task). */
		public id: string,
		/** Computed from the shift_reg's shift_def or shortlabel (or start and end times if the shift_def is the *-shift) */
		public label: string,
		/** Subset of ShiftTypeId */
		public type: string,
		/** from shift_reg.shiftid. The template used for the shift. */
		public shiftDefId: string,
		public period: DomainWsIntervalType,
		public personId: number,
		/** optional: The previous owner if this shift was constructed via a copyrequest, or -1. TODO_LABO, the shift_reg remark also has this information and we do not actually set this field, so we should just remove the field */
		public formerPersonId: number,
		public status: TeamShiftStatusEnum,
		/** Duties on the shift */
		public dutyLines: TeamDuty[],
		/** Activities which are a subset of the shift period */
		public activities: TeamActivity[],
		/** Task assignments which are a subset of the shift period */
		public tasks: TeamActivity[],
		/** Activities or task assignments which are a superset of the shift period */
		public responsibilities: string[],
		/** Can the times be changed */
		public isTimeEditable: boolean,
		/** The number of exchange offers/suggestions/applications. Only defined if status in (swapActionRequired, offerActionRequired) */
		public numSwapSuggestions: number | null = null,
		/** UIlabel of payer unit. Only defined if shift has dutyline with deviating payer. */
		public deviatingPayerUiLabel: string | null = null,
		/** The original duties before availability conversion. Only set on converted shifts, which can be ended. */
		public dutyLinesOriginal: TeamDuty[] | null = null,
		/** Computed from shiftType PublishableLabel or shiftTypeLabel depending on if user can see confidential info. Only set on converted shifts. */
		public absenceLabel: string | null = null,
	) {}
}

export const callInSchema = z.object({
	id: z.int(),
	assignable: z.boolean(),
	shortRule: z.string(),
	priority: z.number().optional().nullable().default(null),
	ruleid: z.string().optional().nullable().default(null),
	descRule: z.string().optional().nullable().default(null),
	descCause: z.string().optional().nullable().default(null),
	cost: z.number().optional().nullable().default(null)
});

export const callInJsonSchema = z.object({
	id: z.int().describe("person1.personid"),
	assignable: z.boolean(),
	shortRule: z.string().describe("Humanly readable short text / rule-violation-group text for the worst ruleviolation (different ruleids can use the same shortRule),"),
	priority: z.number().optional().nullable().default(null).describe("Worst ruleviolation severity. Lower is better. 1 is lowest. Unset if assignable is false"),
	ruleid: z.string().optional().nullable().default(null).describe("Unique ID for the type of the worst ruleviolation (corresponds to workruleitem.id). Unset if there are no rule violations"),
	descRule: z.string().optional().nullable().default(null).describe("Description of the rule violation in a format mentioning the parameters for the persons rulegroup,"),
	descCause: z.string().optional().nullable().default(null).describe("Humanly readable reference to the data which causes the worst rule violation (typically a reference to a timeperiod). Unset if there are no rule violations"),
	cost: z.number().optional().nullable().default(null).describe("The cost of the shift. Should only be displayed if any cost is != 0 (if the cost module is disabled, then the cost is always 0). Unset if assignable is false or the cost module is disabled")
}).describe("One row in the call in list");

/**
	One row in the call in list
	Responsible: LABO, Updated: 20180912
*/
export class CallIn {
	constructor(
		/** person1.personid */
		public id: number,
		public assignable: boolean,
		/** Humanly readable short text / rule-violation-group text for the worst ruleviolation (different ruleids can use the same shortRule), */
		public shortRule: string,
		/** Worst ruleviolation severity. Lower is better. 1 is lowest. Unset if assignable is false */
		public priority: number | null = null,
		/** Unique ID for the type of the worst ruleviolation (corresponds to workruleitem.id). Unset if there are no rule violations */
		public ruleid: string | null = null,
		/** Description of the rule violation in a format mentioning the parameters for the persons rulegroup, */
		public descRule: string | null = null,
		/** Humanly readable reference to the data which causes the worst rule violation (typically a reference to a timeperiod). Unset if there are no rule violations */
		public descCause: string | null = null,
		/** The cost of the shift. Should only be displayed if any cost is != 0 (if the cost module is disabled, then the cost is always 0). Unset if assignable is false or the cost module is disabled */
		public cost: number | null = null,
	) {}
}

export const userSettingsSchema = z.object({
	defaultExchangeCandidateFilter: ExchangeCandidateFilterSchema,
	canSeeConfidentialInfo: z.boolean()
});

export const userSettingsJsonSchema = z.object({
	defaultExchangeCandidateFilter: ExchangeCandidateFilterJsonSchema.describe("The candidateFilter most recently used for for offerOnShiftExchange and its default value for future calls"),
	canSeeConfidentialInfo: z.boolean().describe("Does the backend show certain details from the user. False if staffPlan access item is in use and user does not have it")
}).describe("Settings defined per user which can only be read after logon (see getUserSettings)");

/**
	Settings defined per user which can only be read after logon (see getUserSettings)
	Responsible: LABO, Updated: 20240428
*/
export class UserSettings {
	constructor(
		/** The candidateFilter most recently used for for offerOnShiftExchange and its default value for future calls */
		public defaultExchangeCandidateFilter: ExchangeCandidateFilterEnum,
		/** Does the backend show certain details from the user. False if staffPlan access item is in use and user does not have it */
		public canSeeConfidentialInfo: boolean,
	) {}
}

export const teamPlanSettingsSchema = z.object({
	defaultWorkSalarysort: z.string(),
	possibleCandidateFilters: z.array(ExchangeCandidateFilterSchema),
	swapIsUsed: SwapIsUsedSchema,
	unreadMessageCountPollingSeconds: z.int(),
	teamRosterPollingSeconds: z.int(),
	messagesPollingSeconds: z.int(),
	activeScope: z.int()
});

export const teamPlanSettingsJsonSchema = z.object({
	defaultWorkSalarysort: z.string().describe("The salarysort used on the default shiftDef in getModifiedDutyLines/getShiftCandidateList/assignShiftCandidate"),
	possibleCandidateFilters: z.array(ExchangeCandidateFilterJsonSchema).describe("The candidateFilter values that can be specified in offerOnShiftExchange"),
	swapIsUsed: SwapIsUsedJsonSchema.describe("swapIsUsed=no means that shifts cannot be offered anywhere. swapIsUsed=onlySwapPg means that shifts can only be offered on pesongroups with swapPg, swapIsUsed=everywhere means that shifts can be offered anywhere"),
	unreadMessageCountPollingSeconds: z.int().describe("Interval (in seconds) between polling for the count of unread messages"),
	teamRosterPollingSeconds: z.int().describe("Interval (in seconds) between polling for roster updates"),
	messagesPollingSeconds: z.int().describe("Interval (in seconds) between polling for new messages (chat and notes)"),
	activeScope: z.int().describe("How many days to fetch team roster for")
}).describe("General settings for TeamPlan - not user related (see getSettings)");

/**
	General settings for TeamPlan - not user related (see getSettings)
	Responsible: AGRU, Updated: 20250129
*/
export class TeamPlanSettings {
	constructor(
		/** The salarysort used on the default shiftDef in getModifiedDutyLines/getShiftCandidateList/assignShiftCandidate */
		public defaultWorkSalarysort: string,
		/** The candidateFilter values that can be specified in offerOnShiftExchange */
		public possibleCandidateFilters: ExchangeCandidateFilterEnum[],
		/** swapIsUsed=no means that shifts cannot be offered anywhere. swapIsUsed=onlySwapPg means that shifts can only be offered on pesongroups with swapPg, swapIsUsed=everywhere means that shifts can be offered anywhere */
		public swapIsUsed: SwapIsUsedEnum,
		/** Interval (in seconds) between polling for the count of unread messages */
		public unreadMessageCountPollingSeconds: number,
		/** Interval (in seconds) between polling for roster updates */
		public teamRosterPollingSeconds: number,
		/** Interval (in seconds) between polling for new messages (chat and notes) */
		public messagesPollingSeconds: number,
		/** How many days to fetch team roster for */
		public activeScope: number,
	) {}
}

export const systemInformationSchema = z.object({
	appVersionMin: z.string(),
	serviceVersion: z.string(),
	dbVersion: z.string()
});

export const systemInformationJsonSchema = z.object({
	appVersionMin: z.string().describe("???"),
	serviceVersion: z.string().describe("OldLabel_Type pdcSession.majorVersion"),
	dbVersion: z.string().describe("DatabaseName_Type logRecord.lr_dbVersion")
}).describe("System information for getVersion");

/**
	System information for getVersion
	Responsible: MMI, Updated: 20180912
*/
export class SystemInformation {
	constructor(
		/** ??? */
		public appVersionMin: string,
		/** OldLabel_Type pdcSession.majorVersion */
		public serviceVersion: string,
		/** DatabaseName_Type logRecord.lr_dbVersion */
		public dbVersion: string,
	) {}
}

export const healthCheckSchema = z.object({
	serviceVersion: z.string(),
	dbVersion: z.string()
});

export const healthCheckJsonSchema = z.object({
	serviceVersion: z.string().describe("OldLabel_Type pdcSession.majorVersion"),
	dbVersion: z.string().describe("DatabaseName_Type logRecord.lr_dbVersion")
}).describe("Health information for getHealthCheck");

/**
	Health information for getHealthCheck
	Responsible: AGRU, Updated: 20220509
*/
export class HealthCheck {
	constructor(
		/** OldLabel_Type pdcSession.majorVersion */
		public serviceVersion: string,
		/** DatabaseName_Type logRecord.lr_dbVersion */
		public dbVersion: string,
	) {}
}

export const teamRosterSchema = z.object({
	teamId: z.string(),
	teamShiftList: z.array(z.lazy(() => teamShiftSchema)),
	personList: z.array(z.lazy(() => personSchema))
});

export const teamRosterJsonSchema = z.object({
	teamId: z.string(),
	teamShiftList: z.array(z.lazy(() => teamShiftJsonSchema)),
	personList: z.array(z.lazy(() => personJsonSchema))
}).describe("The list of persons and shifts visible in #teamId in a given timescope, see getTeamRoster");

/**
	The list of persons and shifts visible in #teamId in a given timescope, see getTeamRoster
	Responsible: LABO, Updated: 20180912
*/
export class TeamRoster {
	constructor(
		public teamId: string,
		public teamShiftList: TeamShift[],
		public personList: Person[],
	) {}
}

export const exchangeInfoSchema = z.object({
	exchangeId: z.int(),
	teamShiftList: z.array(z.lazy(() => teamShiftSchema)),
	unitId: z.string(),
	period: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	type: ExchangeTypeSchema,
	status: ExchangeStatusSchema,
	remark: z.string(),
	plannerRemark: z.string(),
	personId: z.int().optional().nullable().default(null),
	persongroupList: z.array(z.string()).optional().nullable().default(null),
	callIn: z.lazy(() => callInSchema).optional().nullable().default(null)
});

export const exchangeInfoJsonSchema = z.object({
	exchangeId: z.int().describe("Id of the exchange_reg. Input for acceptExchange and rejectExchange"),
	teamShiftList: z.array(z.lazy(() => teamShiftJsonSchema)).describe("For the shift module there is only one, for the production module there can be multiple"),
	unitId: z.string().describe("from exchange_reg.unitid. The unitid of the request (also if this is an offer)"),
	period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }).describe("from exchange_reg.start--end. Corresponds to the shift period"),
	type: ExchangeTypeJsonSchema.describe("from exchange_reg.type. Identifies the type of swap when rendering the swap (should only need to look at the request's type)"),
	status: ExchangeStatusJsonSchema.describe("from exchange_reg.status. Identifies swaps which have been assigned between finding the shift and clicking on the swap"),
	remark: z.string().describe("from exchange_reg.remark. The remark from the employee"),
	plannerRemark: z.string().describe("from exchange_reg.plannerRemark. The remark from the planner"),
	personId: z.int().optional().nullable().default(null).describe("from exchange_reg.personid. only undefined when type=dutyrequests. The same as callin.id (if callin is defined)"),
	persongroupList: z.array(z.string()).optional().nullable().default(null).describe("The persongrouplabels corresponding to the #personId's memberships during #period. only undefined when type=dutyrequests. Contains at least one element, if defined"),
	callIn: z.lazy(() => callInJsonSchema).optional().nullable().default(null).describe("Set for offers when status = inProgress, never set for requests")
}).describe("WI137650 Info about the teamShift to be exchanged. One row in the planner-approve-offer list");

/**
	WI137650 Info about the teamShift to be exchanged. One row in the planner-approve-offer list
	Responsible: JBL, Updated: 20230821
*/
export class ExchangeInfo {
	constructor(
		/** Id of the exchange_reg. Input for acceptExchange and rejectExchange */
		public exchangeId: number,
		/** For the shift module there is only one, for the production module there can be multiple */
		public teamShiftList: TeamShift[],
		/** from exchange_reg.unitid. The unitid of the request (also if this is an offer) */
		public unitId: string,
		/** from exchange_reg.start--end. Corresponds to the shift period */
		public period: DomainWsIntervalType,
		/** from exchange_reg.type. Identifies the type of swap when rendering the swap (should only need to look at the request's type) */
		public type: ExchangeTypeEnum,
		/** from exchange_reg.status. Identifies swaps which have been assigned between finding the shift and clicking on the swap */
		public status: ExchangeStatusEnum,
		/** from exchange_reg.remark. The remark from the employee */
		public remark: string,
		/** from exchange_reg.plannerRemark. The remark from the planner */
		public plannerRemark: string,
		/** from exchange_reg.personid. only undefined when type=dutyrequests. The same as callin.id (if callin is defined) */
		public personId: number | null = null,
		/** The persongrouplabels corresponding to the #personId's memberships during #period. only undefined when type=dutyrequests. Contains at least one element, if defined */
		public persongroupList: string[] | null = null,
		/** Set for offers when status = inProgress, never set for requests */
		public callIn: CallIn | null = null,
	) {}
}

export const exchangeSchema = z.object({
	requestInfo: z.lazy(() => exchangeInfoSchema),
	swapInfoList: z.array(z.lazy(() => exchangeInfoSchema))
});

export const exchangeJsonSchema = z.object({
	requestInfo: z.lazy(() => exchangeInfoJsonSchema),
	swapInfoList: z.array(z.lazy(() => exchangeInfoJsonSchema)).describe("there can be multiple swappers making offers for a request")
}).describe("WI137650 Exchange that awaits accept/reject from planner");

/**
	WI137650 Exchange that awaits accept/reject from planner
	Responsible: JBL, Updated: 20230821
*/
export class Exchange {
	constructor(
		public requestInfo: ExchangeInfo,
		/** there can be multiple swappers making offers for a request */
		public swapInfoList: ExchangeInfo[],
	) {}
}

export const absenceTypeSchema = z.object({
	id: z.string(),
	label: z.string(),
	openable: AvailabilityOpenHandlingSchema
});

export const absenceTypeJsonSchema = z.object({
	id: z.string(),
	label: z.string(),
	openable: AvailabilityOpenHandlingJsonSchema
}).describe("Shifttypeid and label for a tpye of absence. See GetAbsence");

/**
	Shifttypeid and label for a tpye of absence. See GetAbsence
	Responsible: LABO, Updated: 20180409
*/
export class AbsenceType {
	constructor(
		public id: string,
		public label: string,
		public openable: AvailabilityOpenHandlingEnum,
	) {}
}

export const teamShiftDefSchema = z.object({
	id: z.string(),
	unitid: z.string(),
	label: z.string(),
	startTime: z.int(),
	endTime: z.int(),
	type: z.string(),
	dutyLines: z.array(z.lazy(() => teamDutySchema)),
	editable: z.boolean(),
	isDefault: z.boolean()
});

export const teamShiftDefJsonSchema = z.object({
	id: z.string().describe("from shift_period_def.shiftid"),
	unitid: z.string().describe("from shift_period_def.unitid. Where the template is defined"),
	label: z.string().describe("from shift_period_def.uilabel"),
	startTime: z.int().describe("Timeoffset between 0 and 1439"),
	endTime: z.int().describe("Timeoffsetend between 1 and 4319"),
	type: z.string().describe("Subset of ShiftTypeId"),
	dutyLines: z.array(z.lazy(() => teamDutyJsonSchema)).describe("Duties on the shift"),
	editable: z.boolean().describe("Whether TeamPlan can alter the shifts' start and end times in getCallInListDef and assignCallInListDef"),
	isDefault: z.boolean().describe("Whether the shift is the default (*)-shiftDef. The default shiftDef does not have representative dutylines, startTime, or endTime.")
}).describe("shift_period_def, a template for a shift_reg. The actual contents used for the shift_reg can vary over time, but TeamPlan mostly works with the shift_period_def which is valid at this point in time.");

/**
	shift_period_def, a template for a shift_reg. The actual contents used for the shift_reg can vary over time, but TeamPlan mostly works with the shift_period_def which is valid at this point in time.
	Responsible: JBL, Updated: 20240514
*/
export class TeamShiftDef {
	constructor(
		/** from shift_period_def.shiftid */
		public id: string,
		/** from shift_period_def.unitid. Where the template is defined */
		public unitid: string,
		/** from shift_period_def.uilabel */
		public label: string,
		/** Timeoffset between 0 and 1439 */
		public startTime: number,
		/** Timeoffsetend between 1 and 4319 */
		public endTime: number,
		/** Subset of ShiftTypeId */
		public type: string,
		/** Duties on the shift */
		public dutyLines: TeamDuty[],
		/** Whether TeamPlan can alter the shifts' start and end times in getCallInListDef and assignCallInListDef */
		public editable: boolean,
		/** Whether the shift is the default (*)-shiftDef. The default shiftDef does not have representative dutylines, startTime, or endTime. */
		public isDefault: boolean,
	) {}
}

export const deviatingShiftInfoSchema = z.object({
	title: z.string(),
	info: z.string()
});

export const deviatingShiftInfoJsonSchema = z.object({
	title: z.string().describe("short description of the type of differences on the shift with respect to its shift_def, that the planner should be informed about. Does not contain newlines."),
	info: z.string().describe("details about the differences with respect to its shift_def. May contain newlines.")
}).describe("Text explaining the deviating info on a shift.");

/**
	Text explaining the deviating info on a shift.
	Responsible: RATJ, Updated: 20190204
*/
export class DeviatingShiftInfo {
	constructor(
		/** short description of the type of differences on the shift with respect to its shift_def, that the planner should be informed about. Does not contain newlines. */
		public title: string,
		/** details about the differences with respect to its shift_def. May contain newlines. */
		public info: string,
	) {}
}

/**
	Returns settings defined per user which can only be read after logon (see userSettings)
	Responsible: LABO, Updated: 20240428
*/
export class GetUserSettings extends WebRequest<UserSettings> {
	public readonly webService = "teamPlan";
	public readonly method = "GetUserSettings";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetUserSettings => {
        return new GetUserSettings();
          }
	public static readonly returnSchema = z.lazy(() => userSettingsSchema);
	public resultFromJSON(json: WebResponseResult<UserSettings>): UserSettings {
		return validate(GetUserSettings.returnSchema, json) as unknown as UserSettings;
	}
}

/**
	Returns the general (not user related) settings for TeamPlan
	Responsible: AGRU, Updated: 20250129
*/
export class GetSettings extends WebRequest<TeamPlanSettings> {
	public readonly webService = "teamPlan";
	public readonly method = "GetSettings";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetSettings => {
        return new GetSettings();
          }
	public static readonly returnSchema = z.lazy(() => teamPlanSettingsSchema);
	public resultFromJSON(json: WebResponseResult<TeamPlanSettings>): TeamPlanSettings {
		return validate(GetSettings.returnSchema, json) as unknown as TeamPlanSettings;
	}
}

/** Responsible: MMI, Updated: 20180608 */
export class GetVersion extends WebRequest<SystemInformation> {
	public readonly webService = "teamPlan";
	public readonly method = "GetVersion";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetVersion => {
        return new GetVersion();
          }
	public static readonly returnSchema = z.lazy(() => systemInformationSchema);
	public resultFromJSON(json: WebResponseResult<SystemInformation>): SystemInformation {
		return validate(GetVersion.returnSchema, json) as unknown as SystemInformation;
	}
}

/** Responsible: AGRU, Updated: 20220509 */
export class GetHealthCheck extends WebRequest<HealthCheck> {
	public readonly webService = "teamPlan";
	public readonly method = "GetHealthCheck";
	public readonly noUserValidation = true;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetHealthCheck => {
        return new GetHealthCheck();
          }
	public static readonly returnSchema = z.lazy(() => healthCheckSchema);
	public resultFromJSON(json: WebResponseResult<HealthCheck>): HealthCheck {
		return validate(GetHealthCheck.returnSchema, json) as unknown as HealthCheck;
	}
}

/**
	Returns the list of persongroups that the current staffuser (see the JWT) can plan for, ie can write to shifts for and read from. See WI86549 Choose department/Team - User story
	Responsible: LABO, Updated: 20180409
*/
export class GetTeams extends WebRequest<Team[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetTeams";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetTeams => {
        return new GetTeams();
          }
	public static readonly returnSchema = z.array(z.lazy(() => teamSchema));
	public resultFromJSON(json: WebResponseResult<Team[]>): Team[] {
		return validate(GetTeams.returnSchema, json) as unknown as Team[];
	}
}

/**
	WI86183 List of shifts - user story
	Responsible: LABO, Updated: 20180605
*/
export class GetTeamRoster extends WebRequest<TeamRoster> {
	public readonly webService = "teamPlan";
	public readonly method = "GetTeamRoster";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, period: DomainWsIntervalType}): GetTeamRoster => {
        return new GetTeamRoster(x.teamId, x.period);
          }
	public static readonly returnSchema = z.lazy(() => teamRosterSchema);
	public resultFromJSON(json: WebResponseResult<TeamRoster>): TeamRoster {
		return validate(GetTeamRoster.returnSchema, json) as unknown as TeamRoster;
	}
}

/**
	Returns person information #personIdList assuming that they are members of the persongroup #teamId
	Responsible: LABO, Updated: 20180409
*/
export class GetEmployees extends WebRequest<Person[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetEmployees";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personIdList: number[],
		public teamId: string,
	) {
		super();
	}

	public static readonly create = (x: {personIdList: number[], teamId: string}): GetEmployees => {
        return new GetEmployees(x.personIdList, x.teamId);
          }
	public static readonly returnSchema = z.array(z.lazy(() => personSchema));
	public resultFromJSON(json: WebResponseResult<Person[]>): Person[] {
		return validate(GetEmployees.returnSchema, json) as unknown as Person[];
	}
}

/**
	Sets favoriteStatus of #teamId to #status
	Responsible: JBL, Updated: 20240208
*/
export class SetFavoriteStatus extends WebRequest<Team> {
	public readonly webService = "teamPlan";
	public readonly method = "SetFavoriteStatus";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public status: FavoriteStatusEnum,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, status: FavoriteStatusEnum}): SetFavoriteStatus => {
        return new SetFavoriteStatus(x.teamId, x.status);
          }
	public static readonly returnSchema = z.lazy(() => teamSchema);
	public resultFromJSON(json: WebResponseResult<Team>): Team {
		return validate(SetFavoriteStatus.returnSchema, json) as unknown as Team;
	}
}

/**
	Sets notificationStatus of #teamId to #status
	Responsible: JBL, Updated: 20240208
*/
export class SetNotificationStatus extends WebRequest<Team> {
	public readonly webService = "teamPlan";
	public readonly method = "SetNotificationStatus";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public status: NotificationStatusEnum,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, status: NotificationStatusEnum}): SetNotificationStatus => {
        return new SetNotificationStatus(x.teamId, x.status);
          }
	public static readonly returnSchema = z.lazy(() => teamSchema);
	public resultFromJSON(json: WebResponseResult<Team>): Team {
		return validate(SetNotificationStatus.returnSchema, json) as unknown as Team;
	}
}

/**
	WI137650 get the exchange for the person at this time
	Responsible: JBL, Updated: 20230821
*/
export class GetExchange extends WebRequest<Exchange> {
	public readonly webService = "teamPlan";
	public readonly method = "GetExchange";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personId: number,
		public shiftStart: Date,
	) {
		super();
	}

	public static readonly create = (x: {personId: number, shiftStart: Date}): GetExchange => {
        return new GetExchange(x.personId, x.shiftStart);
          }
	public static readonly returnSchema = z.lazy(() => exchangeSchema);
	public resultFromJSON(json: WebResponseResult<Exchange>): Exchange {
		return validate(GetExchange.returnSchema, json) as unknown as Exchange;
	}
}

/**
	WI137650 accept exchange offer
	Responsible: JBL, Updated: 20230821
*/
export class AcceptExchange extends WebRequest<WebmethodVoidPlaceholderEnum> {
	public readonly webService = "teamPlan";
	public readonly method = "AcceptExchange";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public unitId: string,
		public requestExchangePeriod: DomainWsIntervalType,
		public offerPersonId: number,
		public offerExchangeId: number,
		public requestPersonId: number | null = null,
	) {
		super();
	}

	public static readonly create = (x: {unitId: string, requestExchangePeriod: DomainWsIntervalType, offerPersonId: number, offerExchangeId: number, requestPersonId: number | null}): AcceptExchange => {
        return new AcceptExchange(x.unitId, x.requestExchangePeriod, x.offerPersonId, x.offerExchangeId, x.requestPersonId);
          }
	public static readonly returnSchema = WebmethodVoidPlaceholderSchema;
	public resultFromJSON(json: WebResponseResult<WebmethodVoidPlaceholderEnum>): WebmethodVoidPlaceholderEnum {
		return validate(AcceptExchange.returnSchema, json) as unknown as WebmethodVoidPlaceholderEnum;
	}
}

/**
	WI137650 cancel exchange (either the request or offer). Note that cancelling the request will also cancel all offers. Cancelling an offer will normally not directly affect the request (unless they are paired, in which case the request is cancelled or it is the non-canceleld offer, in which case the request responsible is set to swapper)
	Responsible: JBL, Updated: 20230821
*/
export class CancelExchange extends WebRequest<WebmethodVoidPlaceholderEnum> {
	public readonly webService = "teamPlan";
	public readonly method = "CancelExchange";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public exchangeId: number,
		public exchangePeriod: DomainWsIntervalType,
		public exchangeUnitId: string,
		public exchangeType: ExchangeTypeEnum,
		public remark: string | null = null,
	) {
		super();
	}

	public static readonly create = (x: {exchangeId: number, exchangePeriod: DomainWsIntervalType, exchangeUnitId: string, exchangeType: ExchangeTypeEnum, remark: string | null}): CancelExchange => {
        return new CancelExchange(x.exchangeId, x.exchangePeriod, x.exchangeUnitId, x.exchangeType, x.remark);
          }
	public static readonly returnSchema = WebmethodVoidPlaceholderSchema;
	public resultFromJSON(json: WebResponseResult<WebmethodVoidPlaceholderEnum>): WebmethodVoidPlaceholderEnum {
		return validate(CancelExchange.returnSchema, json) as unknown as WebmethodVoidPlaceholderEnum;
	}
}

/**
	Offer #shiftId to the persongroups #teamIdList and return the new view of #shiftId. See WI86195 Offer Shift on Shift Exchange - user story
	Responsible: LABO, Updated: 20240916
*/
export class OfferOnShiftExchange extends WebRequest<TeamShift> {
	public readonly webService = "teamPlan";
	public readonly method = "OfferOnShiftExchange";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamIdList: string[],
		public candidateFilter: ExchangeCandidateFilterEnum,
		public remark: string,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamIdList: string[], candidateFilter: ExchangeCandidateFilterEnum, remark: string}): OfferOnShiftExchange => {
        return new OfferOnShiftExchange(x.shiftId, x.teamIdList, x.candidateFilter, x.remark);
          }
	public static readonly returnSchema = z.lazy(() => teamShiftSchema);
	public resultFromJSON(json: WebResponseResult<TeamShift>): TeamShift {
		return validate(OfferOnShiftExchange.returnSchema, json) as unknown as TeamShift;
	}
}

/**
	DEPRECATED. USE cancelExchange INSTEAD Cancel the swap on #shiftId / #teamId and return the new new of #shiftId. See WI86195 Offer Shift on Shift Exchange - user story
	Responsible: LABO, Updated: 20180626
*/
export class CancelOfferOnShiftExchange extends WebRequest<TeamShift> {
	public readonly webService = "teamPlan";
	public readonly method = "CancelOfferOnShiftExchange";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string}): CancelOfferOnShiftExchange => {
        return new CancelOfferOnShiftExchange(x.shiftId, x.teamId);
          }
	public static readonly returnSchema = z.lazy(() => teamShiftSchema);
	public resultFromJSON(json: WebResponseResult<TeamShift>): TeamShift {
		return validate(CancelOfferOnShiftExchange.returnSchema, json) as unknown as TeamShift;
	}
}

/**
	Returns the list of possible absenceTypes (shifttypes and their labels) which can be registerred on #shiftId in #teamId See WI86191 Register absence - user story
	Responsible: LABO, Updated: 20180802
*/
export class GetAbsenceTypes extends WebRequest<AbsenceType[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetAbsenceTypes";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string}): GetAbsenceTypes => {
        return new GetAbsenceTypes(x.shiftId, x.teamId);
          }
	public static readonly returnSchema = z.array(z.lazy(() => absenceTypeSchema));
	public resultFromJSON(json: WebResponseResult<AbsenceType[]>): AbsenceType[] {
		return validate(GetAbsenceTypes.returnSchema, json) as unknown as AbsenceType[];
	}
}

/**
	Create an absence registration (availability_reg) covering the day of #shiftId with #absenceTypeId, possibly with a return date See WI86191 Register absence - user story.
	Responsible: LABO, Updated: 20180808
*/
export class RegisterAbsence extends WebRequest<TeamShift[]> {
	public readonly webService = "teamPlan";
	public readonly method = "RegisterAbsence";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
		public absenceTypeId: string,
		public returnDate: Date | null = null,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string, absenceTypeId: string, returnDate: Date | null}): RegisterAbsence => {
        return new RegisterAbsence(x.shiftId, x.teamId, x.absenceTypeId, x.returnDate);
          }
	public static readonly returnSchema = z.array(z.lazy(() => teamShiftSchema));
	public resultFromJSON(json: WebResponseResult<TeamShift[]>): TeamShift[] {
		return validate(RegisterAbsence.returnSchema, json) as unknown as TeamShift[];
	}
}

/**
	Remove #shiftId in #teamId
	Responsible: RATJ, Updated: 20240619
*/
export class EndAbsence extends WebRequest<TeamShift[]> {
	public readonly webService = "teamPlan";
	public readonly method = "EndAbsence";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string}): EndAbsence => {
        return new EndAbsence(x.shiftId, x.teamId);
          }
	public static readonly returnSchema = z.array(z.lazy(() => teamShiftSchema));
	public resultFromJSON(json: WebResponseResult<TeamShift[]>): TeamShift[] {
		return validate(EndAbsence.returnSchema, json) as unknown as TeamShift[];
	}
}

/**
	WI93035 Mark shift with absence as handled. The exact behavior depends on the planning model: - shiftOnly does nothing, - shift + activity removes the activities, - production turns off the alarm regarding the uncovered resourceassignment.
	Responsible: LABO, Updated: 20180814
*/
export class MarkAsHandled extends WebRequest<TeamShift> {
	public readonly webService = "teamPlan";
	public readonly method = "MarkAsHandled";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string}): MarkAsHandled => {
        return new MarkAsHandled(x.shiftId, x.teamId);
          }
	public static readonly returnSchema = z.lazy(() => teamShiftSchema);
	public resultFromJSON(json: WebResponseResult<TeamShift>): TeamShift {
		return validate(MarkAsHandled.returnSchema, json) as unknown as TeamShift;
	}
}

/**
	Returns the list of persons which can take #shiftId, as well as an indication of how well they fit wrt cost and rule violations The list is sorted from best fit to worst fit, so the caller should not sort the results. See WI 88141
	Responsible: RATJ, Updated: 20240618
*/
export class GetCallInList extends WebRequest<CallIn[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetCallInList";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
		public updatedPeriod: DomainWsIntervalType | null = null,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string, updatedPeriod: DomainWsIntervalType | null}): GetCallInList => {
        return new GetCallInList(x.shiftId, x.teamId, x.updatedPeriod);
          }
	public static readonly returnSchema = z.array(z.lazy(() => callInSchema));
	public resultFromJSON(json: WebResponseResult<CallIn[]>): CallIn[] {
		return validate(GetCallInList.returnSchema, json) as unknown as CallIn[];
	}
}

/**
	Assign #personId a copy of #shiftId, mark #shiftId as handled, and return both the assigned shift and the copies This call does not support assigning shifts to people in other teams (for historical reasons). See WI 88145
	Responsible: LABO, Updated: 20180814
*/
export class AssignCallInList extends WebRequest<TeamShift[]> {
	public readonly webService = "teamPlan";
	public readonly method = "AssignCallInList";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
		public personIdList: number[],
		public updatedPeriod: DomainWsIntervalType | null = null,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string, personIdList: number[], updatedPeriod: DomainWsIntervalType | null}): AssignCallInList => {
        return new AssignCallInList(x.shiftId, x.teamId, x.personIdList, x.updatedPeriod);
          }
	public static readonly returnSchema = z.array(z.lazy(() => teamShiftSchema));
	public resultFromJSON(json: WebResponseResult<TeamShift[]>): TeamShift[] {
		return validate(AssignCallInList.returnSchema, json) as unknown as TeamShift[];
	}
}

/**
	Returns the list of possible teamShiftDef (shift_period_defs and their labels) which can be registerred at some point in #period. See WI147378
	Responsible: LABO, Updated: 20240514
*/
export class GetShiftDefs extends WebRequest<TeamShiftDef[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetShiftDefs";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, period: DomainWsIntervalType}): GetShiftDefs => {
        return new GetShiftDefs(x.teamId, x.period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => teamShiftDefSchema));
	public resultFromJSON(json: WebResponseResult<TeamShiftDef[]>): TeamShiftDef[] {
		return validate(GetShiftDefs.returnSchema, json) as unknown as TeamShiftDef[];
	}
}

/**
	Returns the dutylines corresponding to #shiftDefId defined at #unitid. Note #unitid has to match #teamShiftDef.unitid. Used in the frontend to get a preview of which dutylines are being inserted
	Responsible: LABO, Updated: 20240521
*/
export class GetModifiedDutyLines extends WebRequest<TeamDuty[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetModifiedDutyLines";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public unitid: string,
		public startDate: Date,
		public shiftDefId: string,
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {unitid: string, startDate: Date, shiftDefId: string, period: DomainWsIntervalType}): GetModifiedDutyLines => {
        return new GetModifiedDutyLines(x.unitid, x.startDate, x.shiftDefId, x.period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => teamDutySchema));
	public resultFromJSON(json: WebResponseResult<TeamDuty[]>): TeamDuty[] {
		return validate(GetModifiedDutyLines.returnSchema, json) as unknown as TeamDuty[];
	}
}

/**
	Returns the list of persons which can take #shiftDefId, as well as an indication of how well they fit wrt cost and rule violations. Like getCallInList, but working with a new shift, rather than an existing shift. See WI147378
	Responsible: LABO, Updated: 20240514
*/
export class GetShiftCandidateList extends WebRequest<CallIn[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetShiftCandidateList";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public startDate: Date,
		public shiftDefId: string,
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, startDate: Date, shiftDefId: string, period: DomainWsIntervalType}): GetShiftCandidateList => {
        return new GetShiftCandidateList(x.teamId, x.startDate, x.shiftDefId, x.period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => callInSchema));
	public resultFromJSON(json: WebResponseResult<CallIn[]>): CallIn[] {
		return validate(GetShiftCandidateList.returnSchema, json) as unknown as CallIn[];
	}
}

/**
	Assign #personId a copy of #shiftDefId on #startDate. Like assignCallInList, but working with a new shift, rather than an existing shift. See WI147378
	Responsible: LABO, Updated: 20240514
*/
export class AssignShiftCandidate extends WebRequest<TeamShift> {
	public readonly webService = "teamPlan";
	public readonly method = "AssignShiftCandidate";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public startDate: Date,
		public personId: number,
		public shiftDefId: string,
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, startDate: Date, personId: number, shiftDefId: string, period: DomainWsIntervalType}): AssignShiftCandidate => {
        return new AssignShiftCandidate(x.teamId, x.startDate, x.personId, x.shiftDefId, x.period);
          }
	public static readonly returnSchema = z.lazy(() => teamShiftSchema);
	public resultFromJSON(json: WebResponseResult<TeamShift>): TeamShift {
		return validate(AssignShiftCandidate.returnSchema, json) as unknown as TeamShift;
	}
}

/**
	Remove #shiftId in #teamId. Should call getDeviatingShiftInfo and getRemovedRegistrationInfo first.
	Responsible: JBL, Updated: 20240603
*/
export class RemoveShift extends WebRequest<WebmethodVoidPlaceholderEnum> {
	public readonly webService = "teamPlan";
	public readonly method = "RemoveShift";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public shiftId: string,
		public teamId: string,
	) {
		super();
	}

	public static readonly create = (x: {shiftId: string, teamId: string}): RemoveShift => {
        return new RemoveShift(x.shiftId, x.teamId);
          }
	public static readonly returnSchema = WebmethodVoidPlaceholderSchema;
	public resultFromJSON(json: WebResponseResult<WebmethodVoidPlaceholderEnum>): WebmethodVoidPlaceholderEnum {
		return validate(RemoveShift.returnSchema, json) as unknown as WebmethodVoidPlaceholderEnum;
	}
}

/**
	Edit #shiftId in #teamId, updating its shift_def id and period. Should call getDeviatingShiftInfo and getRemovedRegistrationInfo first. Editing the shift_reg will automatically update activity_regs which start or end at the same time as the shift_reg and delete any activity_regs which are no longer covered by a shift.
	Responsible: RATJ, Updated: 20240618
*/
export class EditShift extends WebRequest<TeamShift> {
	public readonly webService = "teamPlan";
	public readonly method = "EditShift";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public shiftId: string,
		public shiftDefId: string,
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, shiftId: string, shiftDefId: string, period: DomainWsIntervalType}): EditShift => {
        return new EditShift(x.teamId, x.shiftId, x.shiftDefId, x.period);
          }
	public static readonly returnSchema = z.lazy(() => teamShiftSchema);
	public resultFromJSON(json: WebResponseResult<TeamShift>): TeamShift {
		return validate(EditShift.returnSchema, json) as unknown as TeamShift;
	}
}

/**
	Returns infomation about deviations-from-shift-defition. Should be called when editing the shift, such that the user becomes aware of deviations that may be dropped by the edit.
	Responsible: RATJ, Updated: 20240619
*/
export class GetDeviatingShiftInfo extends WebRequest<DeviatingShiftInfo[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetDeviatingShiftInfo";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public shiftId: string,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, shiftId: string}): GetDeviatingShiftInfo => {
        return new GetDeviatingShiftInfo(x.teamId, x.shiftId);
          }
	public static readonly returnSchema = z.array(z.lazy(() => deviatingShiftInfoSchema));
	public resultFromJSON(json: WebResponseResult<DeviatingShiftInfo[]>): DeviatingShiftInfo[] {
		return validate(GetDeviatingShiftInfo.returnSchema, json) as unknown as DeviatingShiftInfo[];
	}
}

/**
	Returns info about registrations that will be removed as a consequence of changing the period of #shiftId to #updatedPeriod. Should be called before removeShift and before editShift. Note that this method does not inform about overlapping shifts, since the frontend should check overlapping shifts (editShift does check for overlapping shifts). Note that this method does not inform about shifts with corresponding exchange_regs, since the frontend should check whether status=offered (if an offered shift is edited, then all the exchange_regs are implicitly cancelled).
	Responsible: LABO, Updated: 20240711
*/
export class GetRemovedRegistrationInfo extends WebRequest<TeamActivity[]> {
	public readonly webService = "teamPlan";
	public readonly method = "GetRemovedRegistrationInfo";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public teamId: string,
		public shiftId: string,
		public isDelete: boolean,
		public updatedPeriod: DomainWsIntervalType | null = null,
	) {
		super();
	}

	public static readonly create = (x: {teamId: string, shiftId: string, isDelete: boolean, updatedPeriod: DomainWsIntervalType | null}): GetRemovedRegistrationInfo => {
        return new GetRemovedRegistrationInfo(x.teamId, x.shiftId, x.isDelete, x.updatedPeriod);
          }
	public static readonly returnSchema = z.array(z.lazy(() => teamActivitySchema));
	public resultFromJSON(json: WebResponseResult<TeamActivity[]>): TeamActivity[] {
		return validate(GetRemovedRegistrationInfo.returnSchema, json) as unknown as TeamActivity[];
	}
}

export const GetUserSettingsAI = { key: 'teamPlan_GetUserSettings' as const,
          webService: 'teamPlan' as const,
           method: 'GetUserSettings' as const,
           description: "Returns settings defined per user which can only be read after logon (see userSettings)",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.lazy(() => userSettingsJsonSchema),
          outputSchema: z.lazy(() => userSettingsSchema),
          requestClass: GetUserSettings
          }
export const GetSettingsAI = { key: 'teamPlan_GetSettings' as const,
          webService: 'teamPlan' as const,
           method: 'GetSettings' as const,
           description: "Returns the general (not user related) settings for TeamPlan",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.lazy(() => teamPlanSettingsJsonSchema),
          outputSchema: z.lazy(() => teamPlanSettingsSchema),
          requestClass: GetSettings
          }
export const GetVersionAI = { key: 'teamPlan_GetVersion' as const,
          webService: 'teamPlan' as const,
           method: 'GetVersion' as const,
           description: "",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.lazy(() => systemInformationJsonSchema),
          outputSchema: z.lazy(() => systemInformationSchema),
          requestClass: GetVersion
          }
export const GetHealthCheckAI = { key: 'teamPlan_GetHealthCheck' as const,
          webService: 'teamPlan' as const,
           method: 'GetHealthCheck' as const,
           description: "",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.lazy(() => healthCheckJsonSchema),
          outputSchema: z.lazy(() => healthCheckSchema),
          requestClass: GetHealthCheck
          }
export const GetTeamsAI = { key: 'teamPlan_GetTeams' as const,
          webService: 'teamPlan' as const,
           method: 'GetTeams' as const,
           description: "Returns the list of persongroups that the current staffuser (see the JWT) can plan for, ie can write to shifts for and read from. See WI86549 Choose department/Team - User story",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.array(z.lazy(() => teamJsonSchema)),
          outputSchema: z.array(z.lazy(() => teamSchema)),
          requestClass: GetTeams
          }
export const GetTeamRosterAI = { key: 'teamPlan_GetTeamRoster' as const,
          webService: 'teamPlan' as const,
           method: 'GetTeamRoster' as const,
           description: "WI86183 List of shifts - user story",
           inputJsonSchema: z.object({ teamId: z.string(), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ teamId: z.string(), period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.lazy(() => teamRosterJsonSchema),
          outputSchema: z.lazy(() => teamRosterSchema),
          requestClass: GetTeamRoster
          }
export const GetEmployeesAI = { key: 'teamPlan_GetEmployees' as const,
          webService: 'teamPlan' as const,
           method: 'GetEmployees' as const,
           description: "Returns person information #personIdList assuming that they are members of the persongroup #teamId",
           inputJsonSchema: z.object({ personIdList: z.array(z.int()), teamId: z.string()}),
           inputSchema: z.object({ personIdList: z.array(z.int()), teamId: z.string()}),
          outputJsonSchema: z.array(z.lazy(() => personJsonSchema)),
          outputSchema: z.array(z.lazy(() => personSchema)),
          requestClass: GetEmployees
          }
export const SetFavoriteStatusAI = { key: 'teamPlan_SetFavoriteStatus' as const,
          webService: 'teamPlan' as const,
           method: 'SetFavoriteStatus' as const,
           description: "Sets favoriteStatus of #teamId to #status",
           inputJsonSchema: z.object({ teamId: z.string(), status: FavoriteStatusJsonSchema}),
           inputSchema: z.object({ teamId: z.string(), status: FavoriteStatusSchema}),
          outputJsonSchema: z.lazy(() => teamJsonSchema),
          outputSchema: z.lazy(() => teamSchema),
          requestClass: SetFavoriteStatus
          }
export const SetNotificationStatusAI = { key: 'teamPlan_SetNotificationStatus' as const,
          webService: 'teamPlan' as const,
           method: 'SetNotificationStatus' as const,
           description: "Sets notificationStatus of #teamId to #status",
           inputJsonSchema: z.object({ teamId: z.string(), status: NotificationStatusJsonSchema}),
           inputSchema: z.object({ teamId: z.string(), status: NotificationStatusSchema}),
          outputJsonSchema: z.lazy(() => teamJsonSchema),
          outputSchema: z.lazy(() => teamSchema),
          requestClass: SetNotificationStatus
          }
export const GetExchangeAI = { key: 'teamPlan_GetExchange' as const,
          webService: 'teamPlan' as const,
           method: 'GetExchange' as const,
           description: "WI137650 get the exchange for the person at this time",
           inputJsonSchema: z.object({ personId: z.int(), shiftStart: z.iso.datetime({ local: true })}),
           inputSchema: z.object({ personId: z.int(), shiftStart: z.coerce.date()}),
          outputJsonSchema: z.lazy(() => exchangeJsonSchema),
          outputSchema: z.lazy(() => exchangeSchema),
          requestClass: GetExchange
          }
export const AcceptExchangeAI = { key: 'teamPlan_AcceptExchange' as const,
          webService: 'teamPlan' as const,
           method: 'AcceptExchange' as const,
           description: "WI137650 accept exchange offer",
           inputJsonSchema: z.object({ unitId: z.string(), requestExchangePeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), offerPersonId: z.int(), offerExchangeId: z.int(), requestPersonId: z.int().optional().nullable().default(null)}),
           inputSchema: z.object({ unitId: z.string(), requestExchangePeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }), offerPersonId: z.int(), offerExchangeId: z.int(), requestPersonId: z.int().optional().nullable().default(null)}),
          outputJsonSchema: WebmethodVoidPlaceholderJsonSchema,
          outputSchema: WebmethodVoidPlaceholderSchema,
          requestClass: AcceptExchange
          }
export const CancelExchangeAI = { key: 'teamPlan_CancelExchange' as const,
          webService: 'teamPlan' as const,
           method: 'CancelExchange' as const,
           description: "WI137650 cancel exchange (either the request or offer). Note that cancelling the request will also cancel all offers. Cancelling an offer will normally not directly affect the request (unless they are paired, in which case the request is cancelled or it is the non-canceleld offer, in which case the request responsible is set to swapper)",
           inputJsonSchema: z.object({ exchangeId: z.int(), exchangePeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), exchangeUnitId: z.string(), exchangeType: ExchangeTypeJsonSchema, remark: z.string().optional().nullable().default(null)}),
           inputSchema: z.object({ exchangeId: z.int(), exchangePeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }), exchangeUnitId: z.string(), exchangeType: ExchangeTypeSchema, remark: z.string().optional().nullable().default(null)}),
          outputJsonSchema: WebmethodVoidPlaceholderJsonSchema,
          outputSchema: WebmethodVoidPlaceholderSchema,
          requestClass: CancelExchange
          }
export const OfferOnShiftExchangeAI = { key: 'teamPlan_OfferOnShiftExchange' as const,
          webService: 'teamPlan' as const,
           method: 'OfferOnShiftExchange' as const,
           description: "Offer #shiftId to the persongroups #teamIdList and return the new view of #shiftId. See WI86195 Offer Shift on Shift Exchange - user story",
           inputJsonSchema: z.object({ shiftId: z.string(), teamIdList: z.array(z.string()), candidateFilter: ExchangeCandidateFilterJsonSchema, remark: z.string()}),
           inputSchema: z.object({ shiftId: z.string(), teamIdList: z.array(z.string()), candidateFilter: ExchangeCandidateFilterSchema, remark: z.string()}),
          outputJsonSchema: z.lazy(() => teamShiftJsonSchema),
          outputSchema: z.lazy(() => teamShiftSchema),
          requestClass: OfferOnShiftExchange
          }
export const CancelOfferOnShiftExchangeAI = { key: 'teamPlan_CancelOfferOnShiftExchange' as const,
          webService: 'teamPlan' as const,
           method: 'CancelOfferOnShiftExchange' as const,
           description: "DEPRECATED. USE cancelExchange INSTEAD Cancel the swap on #shiftId / #teamId and return the new new of #shiftId. See WI86195 Offer Shift on Shift Exchange - user story",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
          outputJsonSchema: z.lazy(() => teamShiftJsonSchema),
          outputSchema: z.lazy(() => teamShiftSchema),
          requestClass: CancelOfferOnShiftExchange
          }
export const GetAbsenceTypesAI = { key: 'teamPlan_GetAbsenceTypes' as const,
          webService: 'teamPlan' as const,
           method: 'GetAbsenceTypes' as const,
           description: "Returns the list of possible absenceTypes (shifttypes and their labels) which can be registerred on #shiftId in #teamId See WI86191 Register absence - user story",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
          outputJsonSchema: z.array(z.lazy(() => absenceTypeJsonSchema)),
          outputSchema: z.array(z.lazy(() => absenceTypeSchema)),
          requestClass: GetAbsenceTypes
          }
export const RegisterAbsenceAI = { key: 'teamPlan_RegisterAbsence' as const,
          webService: 'teamPlan' as const,
           method: 'RegisterAbsence' as const,
           description: "Create an absence registration (availability_reg) covering the day of #shiftId with #absenceTypeId, possibly with a return date See WI86191 Register absence - user story.",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string(), absenceTypeId: z.string(), returnDate: z.iso.datetime({ local: true }).optional().nullable().default(null)}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string(), absenceTypeId: z.string(), returnDate: z.coerce.date().optional().nullable().default(null)}),
          outputJsonSchema: z.array(z.lazy(() => teamShiftJsonSchema)),
          outputSchema: z.array(z.lazy(() => teamShiftSchema)),
          requestClass: RegisterAbsence
          }
export const EndAbsenceAI = { key: 'teamPlan_EndAbsence' as const,
          webService: 'teamPlan' as const,
           method: 'EndAbsence' as const,
           description: "Remove #shiftId in #teamId",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
          outputJsonSchema: z.array(z.lazy(() => teamShiftJsonSchema)),
          outputSchema: z.array(z.lazy(() => teamShiftSchema)),
          requestClass: EndAbsence
          }
export const MarkAsHandledAI = { key: 'teamPlan_MarkAsHandled' as const,
          webService: 'teamPlan' as const,
           method: 'MarkAsHandled' as const,
           description: "WI93035 Mark shift with absence as handled. The exact behavior depends on the planning model: - shiftOnly does nothing, - shift + activity removes the activities, - production turns off the alarm regarding the uncovered resourceassignment.",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
          outputJsonSchema: z.lazy(() => teamShiftJsonSchema),
          outputSchema: z.lazy(() => teamShiftSchema),
          requestClass: MarkAsHandled
          }
export const GetCallInListAI = { key: 'teamPlan_GetCallInList' as const,
          webService: 'teamPlan' as const,
           method: 'GetCallInList' as const,
           description: "Returns the list of persons which can take #shiftId, as well as an indication of how well they fit wrt cost and rule violations The list is sorted from best fit to worst fit, so the caller should not sort the results. See WI 88141",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string(), updatedPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }).optional().nullable().default(null)}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string(), updatedPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }).optional().nullable().default(null)}),
          outputJsonSchema: z.array(z.lazy(() => callInJsonSchema)),
          outputSchema: z.array(z.lazy(() => callInSchema)),
          requestClass: GetCallInList
          }
export const AssignCallInListAI = { key: 'teamPlan_AssignCallInList' as const,
          webService: 'teamPlan' as const,
           method: 'AssignCallInList' as const,
           description: "Assign #personId a copy of #shiftId, mark #shiftId as handled, and return both the assigned shift and the copies This call does not support assigning shifts to people in other teams (for historical reasons). See WI 88145",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string(), personIdList: z.array(z.int()), updatedPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }).optional().nullable().default(null)}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string(), personIdList: z.array(z.int()), updatedPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }).optional().nullable().default(null)}),
          outputJsonSchema: z.array(z.lazy(() => teamShiftJsonSchema)),
          outputSchema: z.array(z.lazy(() => teamShiftSchema)),
          requestClass: AssignCallInList
          }
export const GetShiftDefsAI = { key: 'teamPlan_GetShiftDefs' as const,
          webService: 'teamPlan' as const,
           method: 'GetShiftDefs' as const,
           description: "Returns the list of possible teamShiftDef (shift_period_defs and their labels) which can be registerred at some point in #period. See WI147378",
           inputJsonSchema: z.object({ teamId: z.string(), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ teamId: z.string(), period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => teamShiftDefJsonSchema)),
          outputSchema: z.array(z.lazy(() => teamShiftDefSchema)),
          requestClass: GetShiftDefs
          }
export const GetModifiedDutyLinesAI = { key: 'teamPlan_GetModifiedDutyLines' as const,
          webService: 'teamPlan' as const,
           method: 'GetModifiedDutyLines' as const,
           description: "Returns the dutylines corresponding to #shiftDefId defined at #unitid. Note #unitid has to match #teamShiftDef.unitid. Used in the frontend to get a preview of which dutylines are being inserted",
           inputJsonSchema: z.object({ unitid: z.string(), startDate: z.iso.datetime({ local: true }), shiftDefId: z.string(), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ unitid: z.string(), startDate: z.coerce.date(), shiftDefId: z.string(), period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => teamDutyJsonSchema)),
          outputSchema: z.array(z.lazy(() => teamDutySchema)),
          requestClass: GetModifiedDutyLines
          }
export const GetShiftCandidateListAI = { key: 'teamPlan_GetShiftCandidateList' as const,
          webService: 'teamPlan' as const,
           method: 'GetShiftCandidateList' as const,
           description: "Returns the list of persons which can take #shiftDefId, as well as an indication of how well they fit wrt cost and rule violations. Like getCallInList, but working with a new shift, rather than an existing shift. See WI147378",
           inputJsonSchema: z.object({ teamId: z.string(), startDate: z.iso.datetime({ local: true }), shiftDefId: z.string(), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ teamId: z.string(), startDate: z.coerce.date(), shiftDefId: z.string(), period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => callInJsonSchema)),
          outputSchema: z.array(z.lazy(() => callInSchema)),
          requestClass: GetShiftCandidateList
          }
export const AssignShiftCandidateAI = { key: 'teamPlan_AssignShiftCandidate' as const,
          webService: 'teamPlan' as const,
           method: 'AssignShiftCandidate' as const,
           description: "Assign #personId a copy of #shiftDefId on #startDate. Like assignCallInList, but working with a new shift, rather than an existing shift. See WI147378",
           inputJsonSchema: z.object({ teamId: z.string(), startDate: z.iso.datetime({ local: true }), personId: z.int(), shiftDefId: z.string(), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ teamId: z.string(), startDate: z.coerce.date(), personId: z.int(), shiftDefId: z.string(), period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.lazy(() => teamShiftJsonSchema),
          outputSchema: z.lazy(() => teamShiftSchema),
          requestClass: AssignShiftCandidate
          }
export const RemoveShiftAI = { key: 'teamPlan_RemoveShift' as const,
          webService: 'teamPlan' as const,
           method: 'RemoveShift' as const,
           description: "Remove #shiftId in #teamId. Should call getDeviatingShiftInfo and getRemovedRegistrationInfo first.",
           inputJsonSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
           inputSchema: z.object({ shiftId: z.string(), teamId: z.string()}),
          outputJsonSchema: WebmethodVoidPlaceholderJsonSchema,
          outputSchema: WebmethodVoidPlaceholderSchema,
          requestClass: RemoveShift
          }
export const EditShiftAI = { key: 'teamPlan_EditShift' as const,
          webService: 'teamPlan' as const,
           method: 'EditShift' as const,
           description: "Edit #shiftId in #teamId, updating its shift_def id and period. Should call getDeviatingShiftInfo and getRemovedRegistrationInfo first. Editing the shift_reg will automatically update activity_regs which start or end at the same time as the shift_reg and delete any activity_regs which are no longer covered by a shift.",
           inputJsonSchema: z.object({ teamId: z.string(), shiftId: z.string(), shiftDefId: z.string(), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ teamId: z.string(), shiftId: z.string(), shiftDefId: z.string(), period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.lazy(() => teamShiftJsonSchema),
          outputSchema: z.lazy(() => teamShiftSchema),
          requestClass: EditShift
          }
export const GetDeviatingShiftInfoAI = { key: 'teamPlan_GetDeviatingShiftInfo' as const,
          webService: 'teamPlan' as const,
           method: 'GetDeviatingShiftInfo' as const,
           description: "Returns infomation about deviations-from-shift-defition. Should be called when editing the shift, such that the user becomes aware of deviations that may be dropped by the edit.",
           inputJsonSchema: z.object({ teamId: z.string(), shiftId: z.string()}),
           inputSchema: z.object({ teamId: z.string(), shiftId: z.string()}),
          outputJsonSchema: z.array(z.lazy(() => deviatingShiftInfoJsonSchema)),
          outputSchema: z.array(z.lazy(() => deviatingShiftInfoSchema)),
          requestClass: GetDeviatingShiftInfo
          }
export const GetRemovedRegistrationInfoAI = { key: 'teamPlan_GetRemovedRegistrationInfo' as const,
          webService: 'teamPlan' as const,
           method: 'GetRemovedRegistrationInfo' as const,
           description: "Returns info about registrations that will be removed as a consequence of changing the period of #shiftId to #updatedPeriod. Should be called before removeShift and before editShift. Note that this method does not inform about overlapping shifts, since the frontend should check overlapping shifts (editShift does check for overlapping shifts). Note that this method does not inform about shifts with corresponding exchange_regs, since the frontend should check whether status=offered (if an offered shift is edited, then all the exchange_regs are implicitly cancelled).",
           inputJsonSchema: z.object({ teamId: z.string(), shiftId: z.string(), isDelete: z.boolean(), updatedPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }).optional().nullable().default(null)}),
           inputSchema: z.object({ teamId: z.string(), shiftId: z.string(), isDelete: z.boolean(), updatedPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }).optional().nullable().default(null)}),
          outputJsonSchema: z.array(z.lazy(() => teamActivityJsonSchema)),
          outputSchema: z.array(z.lazy(() => teamActivitySchema)),
          requestClass: GetRemovedRegistrationInfo
          }
export const endpoints = [GetUserSettingsAI, GetSettingsAI, GetVersionAI, GetHealthCheckAI, GetTeamsAI, GetTeamRosterAI, GetEmployeesAI, SetFavoriteStatusAI, SetNotificationStatusAI, GetExchangeAI, AcceptExchangeAI, CancelExchangeAI, OfferOnShiftExchangeAI, CancelOfferOnShiftExchangeAI, GetAbsenceTypesAI, RegisterAbsenceAI, EndAbsenceAI, MarkAsHandledAI, GetCallInListAI, AssignCallInListAI, GetShiftDefsAI, GetModifiedDutyLinesAI, GetShiftCandidateListAI, AssignShiftCandidateAI, RemoveShiftAI, EditShiftAI, GetDeviatingShiftInfoAI, GetRemovedRegistrationInfoAI] as const;
export type Endpoint = (typeof endpoints)[number];
